import './style.scss';
import UiModal from '../../../js/components/UiModal/UiModal';
import { UiTextReviewVanilla } from '@skillbox/front-box/dist/Cards/UiTextReview/UiTextReviewVanilla';

export default (function () {
  const block = document.querySelector('.comments');

  if (!block) {
    return;
  }

  const TextReview = new UiTextReviewVanilla(block, UiModal);
  TextReview.init();

  block.addEventListener('click', async (evt) => {
    TextReview.clickShowMoreHandle(evt);

    const target = evt.target;
    const videoButton = target.closest('[data-video]');
    const socialLink = target.closest('[data-social]');
    const buttonShowComments = target.closest('.comments__button');

    if (videoButton) {
      window.$analytics && window.$analytics.push('review-button-click', {
        blockName: block.dataset.blockName ? block.dataset.blockName : 'Блок без названия'
      });
    }

    if (socialLink) {
      window.$analytics && window.$analytics.push('review-social-click', {
        socialName: socialLink.dataset.social
      });
    }

    if (buttonShowComments && !buttonShowComments.disabled) {
      buttonShowComments.disabled = true
      const { CommentsModal } = await import('./CommentsModal/CommentsModal');
      new CommentsModal(TextReview.showFullComment).init()
      buttonShowComments.disabled = false

      window.$analytics?.push('comments-show-all-comments-button-click')
    }
  });
})();
